export const hosts = {
    barclaycard: 'barclaycard',
    rms: 'rms',
    partners: 'partners',
    eposnow: 'eposnow',
    cardsaver: 'cardsaver',
    worldpay: 'worldpay',
    zerobubble: 'zerobubble',
    deliverect: 'deliverect',
    ncr: 'ncr',
    bna: 'bna',
    oracle: 'oracle',
    zonal: 'zonal',
    tevalis: 'tevalis',
} as const;

type keys = keyof typeof hosts;
export type Host = (typeof hosts)[keys];
